<nav class="pc-nh-navbar">
    <ul>
        <li class="navlogo">
            <img src="../../../assets/img/kulonga-small.png" width="60" alt="">
        <span>ulonga</span>
        </li>
        <li class="homeli"><a href="#home">Home</a></li>
        <li><a  [routerLink]="['universidade']">Universidades</a></li>
        <li><a href="#about">Sobre nós</a></li>
        <li class="navleft"><a  [routerLink]="['login']">Cadastrar-se</a></li>
    </ul>
</nav>